var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 19,
    viewBox: "0 0 57 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_219_7101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.9667 11.4995L32.7203 13.0564H35.3748L35.0504 15.1046H32.3967L31.8178 18.7587H29.3982L30.8736 9.45068H36.2186L35.8922 11.4995H32.9667Z",
    fill: "#008934"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5626 18.7587H36.1433L37.6175 9.45068H40.0372L38.5626 18.7587Z",
    fill: "#008934"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9323 11.4995L43.6856 13.0564H46.4141L46.0905 15.1046H43.3617L43.1067 16.7087H45.9837L45.6596 18.7587H40.3623L41.8377 9.45068H47.1326L46.8088 11.4995H43.9323Z",
    fill: "#008934"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6155 11.4995H51.1834C52.7383 11.4995 53.6889 12.4383 53.4237 14.1048C53.1384 15.9179 51.7779 16.7087 50.3339 16.7087H49.791L50.6155 11.4995ZM47.0466 18.7587H50.479C53.0575 18.7587 55.5275 16.7225 55.9432 14.1048C56.3581 11.4883 54.5441 9.45068 51.9515 9.45068H48.5206L47.0466 18.7587Z",
    fill: "#008934"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7539 11.4995L13.5081 13.0564H16.2357L15.9125 15.1046H13.1839L12.9292 16.7087H15.8071L15.4812 18.7587H10.1848L11.6596 9.45068H16.9557L16.6316 11.4995H13.7539Z",
    fill: "#008934"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4805 11.2972H20.7154C21.5057 11.2972 22.3716 11.4452 22.211 12.4574C22.0515 13.4701 21.1383 13.6178 20.3487 13.6178H20.1135L20.4805 11.2972ZM22.2991 14.9389C23.6579 14.7043 24.55 13.5931 24.7524 12.31C25.067 10.3225 23.8107 9.44531 21.9718 9.44531H18.3537L16.8806 18.7536H19.3017L19.8671 15.1738H19.8918L21.6084 18.7536H24.6211L22.2991 14.9389Z",
    fill: "#008934"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6061 18.7587H25.1851L26.6601 9.45068H29.0798L27.6061 18.7587Z",
    fill: "#008934"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3851 0.169189L10.5765 6.23163L5.39838 15.0001L5.09553 11.7316L4.85803 8.17827H0.101987L0.0541992 8.45866C1.27509 8.45866 1.99738 9.07299 2.19832 10.3307L3.12241 18.6159L3.12817 18.5975L3.14055 18.7189H6.41056L12.2545 6.89836L15.798 0.169189H14.3851Z",
    fill: "#008934"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.21554 10.1555H6.49133L13.7081 0.201416L2.10693 4.05446V4.33284L5.87843 5.93805L6.21554 10.1555Z",
    fill: "#FD853A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_219_7101"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56.1364,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.4024852dcf4f165e7169b60a118ce29a.svg";
export { ForwardRef as ReactComponent };